/**
 * 统一的导航与系统路由配置
 * 所有导航相关的组件与页面都从此处导入
 */

export const NAVIGATION_ROUTES = {
  HOME: '/',
  HISTORY: '/history',
  CLOUD: '/cloud',
  TRASH: '/trash',
  SETTINGS: '/settings',
  DASHBOARD: '/dashboard',
} as const

export interface NavItem {
  label: string
  href: string
  icon?: string
}

export const MAIN_NAV_ITEMS: NavItem[] = [
  {
    label: '传输历史',
    href: NAVIGATION_ROUTES.HISTORY,
  },
  {
    label: '我的云盘',
    href: NAVIGATION_ROUTES.CLOUD,
  },
]

export const SIDEBAR_NAV_ITEMS: NavItem[] = [
  {
    label: '传输历史',
    href: NAVIGATION_ROUTES.HISTORY,
    icon: 'History',
  },
  {
    label: '我的云盘',
    href: NAVIGATION_ROUTES.CLOUD,
    icon: 'Cloud',
  },
  {
    label: '回收站',
    href: NAVIGATION_ROUTES.TRASH,
    icon: 'Trash2',
  },
]
